// import { EmployeeList } from "components/Employee";

import { AuthenticatedLayout } from "../../layouts";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import { EmployeeList } from "../../components/EmployeeList";
import { FC } from "react";
import { PayrollCSSTEarningList } from "../../components/PayrollCSSTEarningList/PayrollCSSTEarningList";

export interface IPayrollCSSTEarningsListPage {}

export const PayrollCSSTEarningsListPage: FC<IPayrollCSSTEarningsListPage> = (
  props: IPayrollCSSTEarningsListPage
) => {
  return (
    <AuthenticatedLayout
      pageTitle="Payroll CSST Earning"
      pageTitleIcon={<DescriptionOutlinedIcon />}
      breadcrumbCurrentPageName=""
      breadcrumbLinks={[
        { text: "", navigateTo: "/payroll-federal-earning/list" },
      ]}
      mainContents={<PayrollCSSTEarningList />}
    />
  );
};
